import * as React from 'react';

import { FormField } from 'components/form';
import CroppedProfileImage from 'components/cropped-profile-image/CroppedProfileImage';

import { uploadImage } from 'modules/influencers/reducers/influencerImages';

import { useThunkDispatch } from 'hooks/use-thunk-dispatch';

import { isRequired } from 'utils/validators';

import './profile-image.scss';

import type {
  Image,
  InfluencerProfileForm
} from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const ProfileImage: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const dispatch = useThunkDispatch();
  const image = profile.profileImage;

  const handleImageChanged = (
    updatedImage: Image
  ): Promise<Image> => (
    dispatch(uploadImage(
      profile, 'profile', updatedImage
    )).then((result: Image) => (
      onChange({
        profileImage: result
      })
    ))
  );

  return (
    <div className="profile-image">
      <FormField
        direction="column"
        showValidationIcon={false}
        validators={[
          isRequired(image ? image.url : '')
        ]}
      >
        <CroppedProfileImage
          image={image}
          canEdit
          type="profile"
          onChange={handleImageChanged}
        />
      </FormField>
    </div>
  );
};

export default ProfileImage;
